module.exports = __webpack_public_path__ + "img/icon_arrow-left.175b72a5.svg";